import { ChakraProvider } from "@chakra-ui/react";
import { system } from "@repo/ui3/theme";
import type { ReactNode } from "react";

export const KarteChakraProvider = ({ children }: { children: ReactNode }) => {
  return <ChakraProvider value={system}>{children}</ChakraProvider>;
};
